<template>
  <div class="logout-container">
    <div class="logout-box card">
      <div class="text-center">
        <h2>Signing Out...</h2>
        <div v-if="oauthProvider" class="oauth-logout-info">
          <p>Signing out from {{ getProviderDisplayName(oauthProvider) }}</p>
          <div class="spinner-border" role="status" aria-hidden="true"></div>
        </div>
        <div v-else>
          <p>You have been signed out successfully.</p>
          <router-link to="/login" class="btn btn-primary">Return to Login</router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import auth from '@/services/auth';

export default {
  name: 'LogoutView',
  data() {
    return {
      oauthProvider: null
    };
  },
  async mounted() {
    // Get OAuth provider before logout
    const user = auth.getUser();
    this.oauthProvider = user ? user.oauth_provider : null;
    
    // Perform logout
    auth.logout();
    
    // Redirect to login after a short delay
    setTimeout(() => {
      this.$router.push('/login');
    }, 2000);
  },
  methods: {
    getProviderDisplayName(provider) {
      const providerNames = {
        'google': 'Google',
        'microsoft': 'Microsoft',
        'linkedin': 'LinkedIn',
        'apple': 'Apple'
      };
      return providerNames[provider] || provider;
    }
  }
};
</script>

<style scoped>
.logout-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: var(--color-surface);
}

.logout-box {
  width: 100%;
  max-width: 400px;
  padding: 2rem;
}

.oauth-logout-info {
  margin-top: 1rem;
}

.oauth-logout-info p {
  margin-bottom: 1rem;
  color: var(--color-text-light);
}

.spinner-border {
  width: 2rem;
  height: 2rem;
  border: 0.25em solid currentColor;
  border-right-color: transparent;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}

@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.text-center {
  text-align: center;
}
</style>
